import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

import CellArrayItemWithTooltip from "../../ui/Table/CellArrayItemWithTooltip";

import { useTeamContext } from "../../../contexts/TeamContext";

import Filters from "./Table/Filters";
import Actions from "./Table/Actions";

export default function Table() {
  const { dispatch, actions, state } = useTeamContext();

  const [keyword, setKeyword] = useState("");

  const filteredItems =
    state.teams &&
    Object.values(state.teams).filter((item) => {
      let available = false;
      if (item.attributes.title.toLowerCase().includes(keyword.toLowerCase()))
        available = true;

      return available;
    });

  const columns = [
    {
      name: "Team Name",
      selector: "attributes.title",
      sortable: true,
    },
    {
      name: "Date Created",
      selector: "attributes.created_at_formatted",
      sortable: true,
      sortFunction: (a, b) =>
        a.attributes.created_at_int - b.attributes.created_at_int,
    },
    {
      name: "Team Type",
      sortable: true,
      selector: "attributes.team_type",
      cell: (row) => (
        <CellArrayItemWithTooltip arr={row.attributes.team_type} />
      ),
    },
    {
      name: "Team Manager",
      sortable: true,
      selector: "attributes.team_manager",
      cell: (row) => (
        <CellArrayItemWithTooltip arr={row.attributes.team_manager} />
      ),
    },
    {
      name: "Team Size",
      selector: "attributes.team_size",
      sortable: true,
      width: "100px",
    },
    {
      name: "Actions",
      sortable: false,
      width: "100px",
      cell: (row) => <Actions row={row} />,
    },
  ];

  useEffect(() => {
    actions.loadTeams(state.enterpriseId, dispatch);
  }, []);

  return (
    <>
      <Filters keyword={keyword} setKeyword={setKeyword} />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={filteredItems || []}
          noDataComponent={
            <div className="mt20">
              {state.teams == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
    </>
  );
}
